<div class="widget widget-calendar">
  <div class="widget-bg">
    <div class="calendar-header" [ngStyle]="{ 'background-color': getBackgroundColor() }">
      <div class="calendar-icon" [ngStyle]="{ 'color': getIconColor() }">
        <i *ngIf="hasIcon()" class="{{ getIcon() }}"></i>
        <svg *ngIf="!hasIcon()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
          <path d="M12.75 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM7.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM8.25 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.75 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM10.5 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM12.75 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM14.25 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 17.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 15.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM15 12.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM16.5 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" />
          <path fill-rule="evenodd" d="M6.75 2.25A.75.75 0 0 1 7.5 3v1.5h9V3A.75.75 0 0 1 18 3v1.5h.75a3 3 0 0 1 3 3v11.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V7.5a3 3 0 0 1 3-3H6V3a.75.75 0 0 1 .75-.75Zm13.5 9a1.5 1.5 0 0 0-1.5-1.5H5.25a1.5 1.5 0 0 0-1.5 1.5v7.5a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-7.5Z" clip-rule="evenodd" />
        </svg>
      </div>

      <h1 [ngStyle]="{ 'color': getTextColor() }">{{ getHeadline() }}</h1>
    </div>
    <div class="calendar-content" *ngIf="this.events" id="calendar-content-{{ this.calendar.id }}">
      <div class="calendar-item"
        *ngFor="let ev of events; let i = index"
        [ngClass]="{'linked': ev.linkEvent != 'DO_NOT_LINK'}"
        (click)="clickItem(ev)"
        id="calendar-item-{{ this.calendar.id }}-{{ i }}"
        >
        <div class="calendar-item-content">
          <div [ngStyle]="{ 'color': getDescriptionColor() }" class="calendar-item-date" *ngIf="!ev.hideDate">
            <span class="calendar-item-date-day">{{ getDay(ev) }}</span>
            <span class="calendar-item-date-month"> {{ getMonth(ev) }}</span>
          </div>
          <h3 [ngStyle]="{ 'color': getTextColor() }">{{ ev.title }}</h3>
          <div class="calendar-item-description" [ngStyle]="{ 'color': getDescriptionColor() }" [innerHTML]="ev.description"></div>
        </div>
        <div class="calendar-chevron" *ngIf="ev.linkEvent != 'DO_NOT_LINK'">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .widget-calendar h1,
  .widget-calendar h2,
  .widget-calendar h3,
  .widget-calendar h4,
  .widget-calendar h5,
  .widget-calendar h6 {
    padding: 0;
    margin: 0;
    border: 0;
  }

  .widget-calendar .widget-bg {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    cursor: default;
  }

    /* ------ HEADER ------ */

    .widget-calendar .calendar-header {
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: start;
      padding: 10px 15px;
      background: #d2d9e0;
    }
      .widget-calendar .calendar-icon {
        color: #5875BB;
        width: 20px;
        height: 20px;
      }
        .widget-calendar .calendar-icon i {
          height: 20px !important;
          font-size: 20px !important;
        }
      .widget-calendar .calendar-header h1 {
        font-size: 26px;
        font-weight: bold;
        color: #1d365b;
      }

      /* ------ CONTENT ------ */

    .widget-calendar .calendar-content {
      flex: 1;
      overflow-y: auto;
      background: #fff;
    }
      .widget-calendar .calendar-item {
        display: flex;
        border-bottom: 1px solid #444;
        padding: 20px 15px;
      }
        .widget-calendar .calendar-item.linked {
          cursor: pointer;
        }
        .widget-calendar .calendar-item.linked:hover {
          background: #eff2f4;
        }

        /* ------ CONTENT: DATE ------ */

        .widget-calendar .calendar-item-date {
          font-size: 14px;
          color: #727272;
          font-weight: 400;
          line-height: 1;
          padding-bottom: 6px;
          text-transform: uppercase;
        }
          .widget-calendar .calendar-item-date .calendar-item-date-day {}
          .widget-calendar .calendar-item-date .calendar-item-date-month {}

        /* ------ CONTENT: NAME/DESC ------ */

        .widget-calendar .calendar-item-content {
          flex: 1;
          padding: 0 20px 0 0;
        }
          .widget-calendar .calendar-item-content h3 {
            font-size: 18px;
            color: #2A2A2A;
            line-height: 1.2;
            padding-bottom: 4px;
          }
          .widget-calendar .calendar-item-content .calendar-item-description {
            margin: 0;
            padding: 0;
            font-size: 14px;
            font-weight: 400;
            color: #727272;
            line-height: 1.2;
          }

        /* ------ CONTENT: CHEVRON ------ */

        .widget-calendar .calendar-chevron {
          width: 35px;
          display: none;
        }

</style>